"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConferenceLeads() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="conferenceleads" ref={ref} className="w-full py-16 !rounded-none !bg-[hsl(159,56%,14%)] md:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-4xl font-bold transition-all duration-700 opacity-100 translate-y-0 !font-serif !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">Conference leads</h2>
        <span className="block w-32 h-1 bg-accent mx-auto mt-4"></span>
      </div>
    </section>;
}